function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M19.54 6.54l-3.07-3.07A5.003 5.003 0 0012.93 2H8C5 2 3 4 3 7v10c0 3 2 5 5 5h8c3 0 5-2 5-5v-6.93c0-1.33-.53-2.6-1.46-3.53z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.5 13.25V9.5H10c-1.65 0-3 1.35-3 3v1h4.25c.14 0 .25-.11.25-.25zm1.25.25H17v-1c0-1.65-1.35-3-3-3h-1.5v3.75c0 .14.11.25.25.25zm-1.5 1H7v1c0 1.65 1.35 3 3 3h1.5v-3.75c0-.14-.11-.25-.25-.25zm1.25.25v3.75H14c1.65 0 3-1.35 3-3v-1h-4.25c-.14 0-.25.11-.25.25z"
})));